import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://skindevreplica.api.tatamotors/api", // Set your API base URL
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.response.use(
  (response) => response, // If response is successful, return it
  (error) => {
    if (
      error.response &&
      error.response.data.detail ===
        "Authentication credentials were not provided."
    ) {
      localStorage.clear(); // Clear local storage
      window.location.href = "/login"; // Redirect to login
    }
    return Promise.reject(error); // Pass error to catch block
  }
);


// Add static config values
axiosInstance.config = {

  //  REACT_APP_ENCRYPTION_KEY="3743EF16DA4378CC938A20FD9FC6CC39"
  //  REACT_APP_IV="000102030405060708090a0b0c0d0e0f"
  //  REACT_APP_CAPTCHA_SUCCESS_MSG = "CAPTCHA validated successfully"
  
  REACT_APP_ENCRYPTION_KEY:"16A1CEB9651C300AF5DDE9BBD5F8A04B",
  REACT_APP_IV:"000102030405060708090a0b0c0d0e0f",
  REACT_APP_CAPTCHA_SUCCESS_MSG :"CAPTCHA validated successfully",



  // ENCRYPTION_KEY: "16A1CEB9651C300AF5DDE9BBD5F8A04B",
  // IV: "000102030405060708090a0b0c0d0e0f",
  // CAPTCHA_SUCCESS_MSG: "CAPTCHA validated successfully",
};

// Response interceptor for auth handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.data.detail ===
        "Authentication credentials were not provided."
    ) {
      localStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
